import { render } from "./payment-body.vue?vue&type=template&id=3ca45054&scoped=true"
import script from "./payment-body.vue?vue&type=script&lang=js"
export * from "./payment-body.vue?vue&type=script&lang=js"

import "./payment-body.vue?vue&type=style&index=0&id=3ca45054&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca45054"]])

export default __exports__